import {
  type ShopifyAnalyticsPayload,
  type ShopifyAnalyticsProduct,
} from '@shopify/hydrogen';
import type {
  Product,
  ProductVariant,
} from '@shopify/hydrogen/storefront-api-types';
import invariant from 'tiny-invariant';
import AddToCartButton from '~/components/product/buttons/AddToCartButton';
import BuyNowButton from '~/components/product/buttons/BuyNowButton';
import ProductOptions from '~/components/product/Options';
import {SanityCustomProductOption} from '~/lib/sanity';
import {hasMultipleProductOptions} from '~/lib/utils';

export default function ProductForm({
  product,
  selectedVariant,
  analytics,
  customProductOptions,
  lang,
}: {
  product: Product;
  selectedVariant: ProductVariant;
  analytics: ShopifyAnalyticsPayload;
  customProductOptions?: SanityCustomProductOption[];
  lang: String;
}) {
  const isOutOfStock = !selectedVariant?.availableForSale;
  const multipleProductOptions = hasMultipleProductOptions(product.options);
  let availableForSale = selectedVariant?.availableForSale;

  invariant(
    analytics?.products?.[0],
    'Missing product analytics data for product page',
  );

  const productAnalytics: ShopifyAnalyticsProduct = {
    ...analytics.products[0],
    quantity: 1,
  };

  return (
    <>
      {multipleProductOptions && (
        <>
          <ProductOptions
            options={product.options}
            selectedVariant={selectedVariant}
            customProductOptions={customProductOptions}
            allVariants={product.variants}
            lang={lang}
            availableForSale={availableForSale}
          />
          <div className="my-4 w-full border-b border-gray" />
        </>
      )}

      <div
        className={`flex flex-col space-y-2 ${
          availableForSale === true ? ' ' : ' blockAddToCart'
        }`}
      >
        <AddToCartButton
          lines={[
            {
              merchandiseId: selectedVariant.id,
              quantity: 1,
            },
          ]}
          disabled={isOutOfStock}
          analytics={{
            products: [productAnalytics],
            totalValue: parseFloat(productAnalytics.price),
          }}
          buttonClassName="w-full"
        />
        <BuyNowButton
          lines={[{merchandiseId: selectedVariant.id, quantity: 1}]}
          disabled={isOutOfStock}
        />
        {availableForSale === false && (
          <>
            {lang === 'EN' ? (
              <div className="chooseYourSize text-lg font-bold text-red">
                Choose your size
              </div>
            ) : (
              <div className="chooseYourSize text-lg font-bold text-red">
                Wählen Sie Ihre Größe
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
